import type { ThemeMode } from '../types/settings';

let systemListener: (() => void) | null = null;

export function applyTheme(mode: ThemeMode): void {
  systemListener?.();
  systemListener = null;

  if (mode === 'dark') {
    document.documentElement.classList.add('dark');
  } else if (mode === 'light') {
    document.documentElement.classList.remove('dark');
  } else {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const update = () => {
      if (mq.matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };
    update();
    mq.addEventListener('change', update);
    systemListener = () => mq.removeEventListener('change', update);
  }
}
